import {} from ".";
import { BookingApi, Configuration, BookingStatusEnum } from "../gen/adprovisioning";
import { BookingRequest, Booking, BOOKING_STATUS, BookingAsset } from "../model/Booking";
import { Slot, SLOT_TYPES } from "../model/Slot";
import { AuthInfo, getAuthInfo } from "../utility/AccountUtility";
import { ErrorNotFound } from "./Errors";
function convertNetAssetToAsset(net) {
    let result = new BookingAsset();
    result.id = net.assetId;
    result.url = net.assetUrl;
    result.selected = net.selected;
    result.refSlot = net.refSlot;
    return result;
}
function convertBookingToNetBooking(booking) {
    let result = {
        id: booking.id,
        name: booking.name,
        refBrand: booking.brand,
        refAdvertiser: booking.advertiser,
        budgetSpent: booking.volumeSpent,
        budgetTotal: booking.volumeTotal,
        start: booking.start,
        end: booking.end,
    };
    result.refSlot = booking.slotId;
    result.assets = booking.assets.map(convertAssetToNetAsset);
    result.status = BookingStatusEnum[String(booking.status).charAt(0).toUpperCase() + String(booking.status).slice(1)];
    return result;
}
function convertAssetToNetAsset(net) {
    let result = {};
    result.assetId = net.id;
    result.assetUrl = net.url;
    result.selected = net.selected;
    result.refSlot = net.refSlot;
    return result;
}
function convertNetBookingToBooking(net) {
    let result = new Booking({
        id: net.id,
        brand: net.refBrand,
        advertiser: net.refAdvertiser,
        slotId: net.refSlot,
        name: net.name,
        volumeSpent: net.budgetSpent,
        volumeTotal: net.budgetTotal,
        start: net.start,
        end: net.end,
        status: undefined,
    });
    result.status = BOOKING_STATUS[net.status];
    if (!net.assets) {
        net.assets = Array();
    }
    result.assets = net.assets.map(convertNetAssetToAsset);
    return result;
}
function convertNetBookingArrayToBookingArray(nets) {
    let result = [];
    for (let net of nets) {
        result.push(convertNetBookingToBooking(net));
    }
    return result;
}
function convertBookingArrayToNetBookingArray(bookings) {
    let result = [];
    for (let booking of bookings) {
        result.push(convertBookingToNetBooking(booking));
    }
    return result;
}
export class DefaultBookingController {
    backendUrl;
    constructor(backendUrl) {
        this.backendUrl = backendUrl;
    }
    async endBookingRequest(bookingRequestId) {
        let api = this.getBookingApiClient();
        return api.bookingrequestEndBookingIdPost({
            bookingId: bookingRequestId
        });
    }
    async endBooking(bookingId) {
        let api = this.getBookingApiClient();
        return api.bookingEndBookingIdPost({
            bookingId: bookingId
        });
    }
    async pauseBooking(bookingId) {
        let api = this.getBookingApiClient();
        return api.bookingBookingIdCmdPost({
            bookingId: bookingId,
            cmd: "pause"
        });
    }
    async restartBooking(bookingId) {
        let api = this.getBookingApiClient();
        return api.bookingBookingIdCmdPost({
            bookingId: bookingId,
            cmd: "restart"
        });
    }
    async confirmBooking(bookingRequestId, slotToAssetMap) {
        let api = this.getBookingApiClient();
        let netBooking = await api.bookingrequestConfirmBookingIdPost({
            bookingId: bookingRequestId,
            requestBody: Object.fromEntries(slotToAssetMap),
        });
        let booking = convertNetBookingToBooking(netBooking);
        return booking;
    }
    async getBookingRequests() {
        let api = this.getBookingApiClient();
        let netBookingRequest = await api.bookingrequestsGet();
        return netBookingRequest.map(convertNetBookingToBooking);
    }
    async getBookingRequest(id) {
        let bookingRequests = await this.getBookingRequests();
        for (let br of bookingRequests) {
            if (br.id == id) {
                return br;
            }
        }
        throw new ErrorNotFound();
    }
    getBookingApiClient() {
        let authInfo = getAuthInfo();
        return new BookingApi(new Configuration({
            accessToken: authInfo.getToken(),
            basePath: this.backendUrl
        }));
    }
    async requestBooking(bookingRequest) {
        let api = this.getBookingApiClient();
        let netBookingRequest = convertBookingToNetBooking(bookingRequest);
        let retrievedNetBookingRequest = await api.slotSlotIdBookingRequestPost({
            slotId: bookingRequest.slotId,
            booking: netBookingRequest,
        });
        return convertNetBookingToBooking(retrievedNetBookingRequest);
    }
    async getBookingsForSlot(slotId) {
        let api = this.getBookingApiClient();
        let netBookings = await api.slotSlotIdBookingsGet({ slotId: slotId });
        return convertNetBookingArrayToBookingArray(netBookings);
    }
    async getAllBookings() {
        let api = this.getBookingApiClient();
        let netBookings = await api.bookingsGet();
        return convertNetBookingArrayToBookingArray(netBookings);
    }
    async getBooking(bookingId) {
        let api = this.getBookingApiClient();
        let netBooking = await api.bookingBookingIdGet({
            bookingId: bookingId
        });
        return convertNetBookingToBooking(netBooking);
    }
    getBookingsForGame(gameId) {
        throw new Error("Method not implemented.");
    }
    getSlotsForGame(gameId) {
        throw new Error("Method not implemented.");
    }
}
